import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import menuReducer from './menuSlice';
import eventsReducer from './eventsSlice';
import tokensReducer from './tokensSlice';
import promoReducer from './promoSlice';
import statsReducer from './statsSlice';

// Połącz wszystkie reducery
const rootReducer = combineReducers({
  menu: menuReducer,
  events: eventsReducer,
  tokens: tokensReducer,
  stats: statsReducer,
  promo: promoReducer
});

// Konfiguracja persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'menu',
    'events',
    'tokens',
    'promo',
    'stats'
  ]
};

// Stwórz persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Konfiguracja store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        },
      }),
});

// Stwórz persistor
export const persistor = persistStore(store);

export default store;